/* eslint-disable max-statements */
import { useMutation } from '@tanstack/react-query';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

interface HookProps {
  screenshotLink: string;
}

export const useDownloadScreenshot = () => {
  return useMutation({
    mutationFn: async ({ screenshotLink }: HookProps) => {
      const result = await apiClient.declarationsDocuments.getScreenshot.mutation({
        query: { url: screenshotLink },
      });

      if (result.status !== 200) throw result.body;

      const response = result.body as Blob;
      const href = window.URL.createObjectURL(response);
      const link = document.createElement('a');
      link.href = href;
      link.setAttribute('download', 'screenshot.jpeg');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(href);
    },
    onError: (error) => {
      showErrorToast(error, 'Error downloading the screenshot!');
    },
  });
};
